module.exports = __webpack_public_path__ + "static/media/save-illustration.72568196.svg";